
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { signup, signInWithGoogle } from "../Utils/FirebaseAuth";
import { FormGroup, FormControl, Form, Button } from "react-bootstrap";

export default class FirebaseSignUp extends Component {

  constructor() {
    super();
    this.state = {
      error: null,
      email: '',
      password: '',
      userName: '',
      type: 'individual',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.googleSignIn = this.googleSignIn.bind(this);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
    console.log(event.target.name);
    console.log(event.target.value);
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.setState({ error: '' });
    try {
      await signup(this.state.email, this.state.password, this.state.userName);
      console.log(this.state);
    } catch (error) {
      this.setState({ error: error.message });
      console.log(error);
    }
  }

  async googleSignIn() {
    try {
      await signInWithGoogle();
    } catch (error) {
      this.setState({ error: error.message });
    }
  }


  render() {
    return (


      <div className='d-flex align-items-center mb-5'>
        <div className='flex-1 container'>
          <div className="signInDiv margin-top-100">
            <p className='bold-font h4  themeColor2 text-center'>Sign Up</p>
            <p className='para light-font '></p>

            <div className='googleButton' onClick={this.googleSignIn.bind(this)}>
              <img width="30px" src='/Images/google-logo.ico' className='mr-3' />
              Sign up with Google
            </div>
            <div className='googleButton mt-2' >
              <img width="30px" src='/Images/facebook.png' className='mr-3' />
              Sign up with Facebook
            </div>
            <div className='position-relative my-5' >
              <div className='app-border mx-auto'></div>
              <span className='login-opt light-font para'>or Sign up with Email</span>
            </div>

            <form className='' onSubmit={this.handleSubmit}>

            <div className="form-group">
            <span className='bold-semifont para'>Type*</span>
              <select className="form-control" placeholder="Business Type" onChange={this.handleChange} name="type" value={this.state.type} aria-label="Default select example">
                <option selected>Select Type</option>
                <option value="business">Business</option>
                <option value="individual">Individual</option>
              </select>
            </div>
            {this.state.type == "business" ?
            <>
              <div className="form-group">
              <span className='bold-semifont para'>Business Name*</span>
                <input className="form-control" type="text" placeholder="Business Name" name="businessName" onChange={this.handleChange} value={this.state.businessName} ></input>
              </div>
              <div className="form-group">
              <span className='bold-semifont para'>License Id*</span>
                <input className="form-control" type="text" placeholder="License Id" name="licenseId" onChange={this.handleChange} value={this.state.licenseId} ></input>
              </div>
            </>
            :
            ""
            }
            <div className="form-group">
            <span className='bold-semifont para'>Name*</span>
              <input className="form-control" type="text" placeholder="User name" name="userName" onChange={this.handleChange} value={this.state.userName} ></input>
            </div>

            <div className="form-group">
              <span className='bold-semifont para'>Email*</span>
              <input className="form-control" placeholder="Email" name="email" type="email" onChange={this.handleChange} value={this.state.email}></input>
            </div>
            <div className="form-group">
              <span className='bold-semifont para'>Phone No.*</span>
              <input className="form-control" placeholder="Phone Number" name="phoneNumber" type="text" onChange={this.handleChange} value={this.state.phoneNumber}></input>
            </div>
            <div className="form-group">
              <span className='bold-semifont para'>Password*</span>
              <input className="form-control" placeholder="Password" name="password" onChange={this.handleChange} value={this.state.password} type="password"></input>
            </div>

            <div className="form-group text-center">
              {this.state.error ? 
                <p className="text-danger">{this.state.error}</p>
               : null}
              <Button className='round-button'  type="submit">Sign up</Button>
            </div>
            {/* <p className='light-font'>You can also log in with any of these services</p> */}
            {/* <Button className="btn btn-danger mr-2" type="button" onClick={this.googleSignIn}>
            Sign in with Google
          </Button> */}

            {/* <hr /> */}
            <div className='app-border'></div>
            <p className='light-font'>
            Already have an account? <Link to="/login" style={{color:"#28b8dc"}}>Sign In</Link>
            </p>
          </form>
          </div>
        </div>
      </div>


      // <div className="container">
      //   <form className="mt-5 py-5 px-5" onSubmit={this.handleSubmit}>

      //     <p className="lead">Create an account.</p>
      //     <div className="form-group">
      //       <input className="form-control" placeholder="User name" name="userName" onChange={this.handleChange} value={this.state.userName} ></input>
      //     </div>
      //     <div className="form-group">
      //       <input className="form-control" placeholder="Email" name="email" type="email" onChange={this.handleChange} value={this.state.email}></input>
      //     </div>         
      //     <div className="form-group">
      //       <input className="form-control" placeholder="Password" name="password" onChange={this.handleChange} value={this.state.password} type="password"></input>
      //     </div>
      //      <div className="form-group">
      //       {this.state.error ? <p className="text-danger">{this.state.error}</p> : null}
      //       <button className="btn btn-primary px-5" type="submit">Sign up</button>
      //     </div>
      //     <p>You can also sign up with any of these services</p>
      //     <button className="btn btn-danger mr-2" type="button" onClick={this.googleSignIn}>
      //       Sign up with Google
      //     </button>

      //     <hr></hr>
      //     <p>Already have an account? <Link to="/login">Login</Link></p>
      //   </form>
      // </div>
    )
  }
}